<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">Contents</h1>
<h2 class="toc-fm"><a id="pagev" title="v"></a><a href="#/xhtml/List_of_Plates">List of Plates</a></h2>
<h2 class="toc-fm1"><a href="#/xhtml/List_of_Figures">List of Figures</a></h2>
<h2 class="toc-fm1"><a href="#/xhtml/Abbreviations">Abbreviations</a></h2>
<h2 class="toc-fm1"><a href="#/xhtml/Acknowledgements">Acknowledgements</a></h2>
<h2 class="toc-fm1"><a href="#/xhtml/Preface">Preface</a></h2>
<h2 class="toc-fm1"><a href="#/xhtml/Introduction">Introduction</a></h2>
<h2 class="toc-ch"><a href="#/xhtml/Chapter01"><span class="spacet">1.</span> The Formation of MI(R)</a></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter02" title="Link target outside of Sample"><span class="spacet">2.</span> The Outbreak of War</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter03" title="Link target outside of Sample"><span class="spacet">3.</span> The Technical Section</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter04" title="Link target outside of Sample"><span class="spacet">4.</span> Recruitment and Training</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter05" title="Link target outside of Sample"><span class="spacet">5.</span> Escape, Evasion and Deception</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter06" title="Link target outside of Sample"><span class="spacet">6.</span> Central and Eastern Europe</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter07" title="Link target outside of Sample"><span class="spacet">7.</span> Romania and the Balkans</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter08" title="Link target outside of Sample"><span class="spacet">8.</span> Scandinavia</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter09" title="Link target outside of Sample"><span class="spacet">9.</span> Western Europe, Britain and the Americas</span></h2>
<h2 class="toc-ch1"><span href="#/xhtml/Chapter10" title="Link target outside of Sample"><span class="spacett">10.</span> The Caucasus, Middle East and Africa</span></h2>
<h2 class="toc-ch1"><span href="#/xhtml/Chapter11" title="Link target outside of Sample"><span class="spacett">11.</span> Asia, the Far East and Australia</span></h2>
<h2 class="toc-ch1"><span href="#/xhtml/Chapter12" title="Link target outside of Sample"><span class="spacett">12.</span> MI(R) and SOE</span></h2>
<h2 class="toc-bm"><span href="#/xhtml/Conclusion" title="Link target outside of Sample">Conclusion</span></h2>
<h2 class="toc-bm"><span href="#/xhtml/Conclusion" title="Link target outside of Sample">On-line Appendices</span> (<span class="weblink"><span class="underline"><a href="https://independent.academia.edu/MalcolmAtkin" target="_blank">https://independent.academia.edu/MalcolmAtkin)</a></span></span></h2>
<h2 class="toc-bm1"><span href="#/xhtml/Conclusion" title="Link target outside of Sample">1. Officers of MI(R), 1938–1940</span></h2>
<h2 class="toc-bm1"><span href="#/xhtml/Conclusion" title="Link target outside of Sample">2. Selected source documents</span></h2>
<h2 class="toc-bm"><span href="#/xhtml/Notes" title="Link target outside of Sample">Notes</span></h2>
<h2 class="toc-bm"><span href="#/xhtml/Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2af423a5